import {
  put, call, all, takeLatest,
} from 'redux-saga/effects';
import { notification } from 'antd';
import { setProdReports, setProdReportFailure } from '../state/action/prodLogAction';
import { GET_PROD_REPORTS } from '../state/types';
import fetch from '../services/fetch';
import { BASE_URL } from '../config';

function* getReports({ projectNo }) {
  let status = 0;
  try {
    const projNo = encodeURIComponent(projectNo.projectNo).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');
    const res = yield fetch(`${BASE_URL}/reports?projectNumber=${projNo}&type=ProductionLog`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    if (res.status === 403) {
      status = res.status;
      throw new Error('Unauthorized');
    }
    const response = yield res.json();
    yield put(setProdReports({ response }));
  } catch (error) {
    yield put(setProdReportFailure());
    if (status !== 403) {
      notification.error({
        message: 'There was a problem fetching the report details.',
        description: `${error}`,
      });
    }
  }
}

function* prodLogWatcher() {
  yield takeLatest(GET_PROD_REPORTS, getReports);
}

function* prodLogSagas() {
  yield all([
    call(prodLogWatcher),
  ]);
}

export default prodLogSagas;
